export const MODULES_ENUM = {
  GERAL: "GERAL",
  AGRIC: "AGRIC",
  PEC: "PEC",
  PLUVIOMETRO: "PLUVIOMETRO",
  ESTOQUE: "ESTOQUE",
  FINAN: "FINAN",
  MONITORAMENTO_FISCAL: "MONITORAMENTO_FISCAL",
  MAPA: "MAPA",
  FISCAL: "FISCAL",
  PATRIMONIO: "PATRIMONIO",
  STORAGE: "STORAGE",
  NFE: "NFE",
  CONFIG: "CONFIG",
  NDVI: "NDVI",
  NOTIFICATION: "NOTIFICATION",
  PARTNER: "PARTNER",
};
